import md5 from 'crypto-js/md5';

export const getGravatarUrl = (email: string, size: number = 40): string => {
  const emailHash = md5(email.toLowerCase().trim()).toString();
  return `https://www.gravatar.com/avatar/${emailHash}?s=${size}&d=404`;
};

export const checkGravatarExists = async (email: string): Promise<boolean> => {
  try {
    const url = getGravatarUrl(email, 40);
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok;
  } catch {
    return false;
  }
};

export const getInitialsFromEmail = (email: string): string => {
  const localPart = email.split('@')[0];
  return localPart.charAt(0).toUpperCase();
};
